import { Injectable } from '@angular/core';
import { FormalApi } from 'src/app/api/observations/formal/formal.api';
import { CreateNotificationDTO } from 'src/app/model/communication/create-notification-dto.model';
import { DateTimeDTO } from 'src/app/model/date-time-dto.model';
import { FormalCreateDto } from 'src/app/model/observation/formal/formal-create-dto.model';
import { FormalCreateNoteRequestDTO } from 'src/app/model/observation/formal/formal-create-note-request-dto.model';
import { FormalDistributeNotesDTO } from 'src/app/model/observation/formal/formal-distribute-notes-dto.model';
import { FormalSummaryUpdateDto } from 'src/app/model/observation/formal/formal-summary-update-dto.model';
import { FormalUpdateNoteRequestDTO } from 'src/app/model/observation/formal/formal-update-note-request-dto.model';
import { SignatureDTO } from 'src/app/model/signature-dto.model';

@Injectable()
export class FormalService {
    constructor(private formalApi: FormalApi) { }

    getObservationDetails = (userId: string, formalId: string) =>
        this.formalApi.getDetails(userId, formalId);

    createFormal = (observation: FormalCreateDto) =>
        this.formalApi.createFormal(observation);

    beginSection = (observationId: string, section: number, notification?: CreateNotificationDTO) =>
        this.formalApi.beginSection(observationId, section, notification);

    completeSection = (observationId: string, section: number, complete: boolean) =>
        this.formalApi.completeSection(observationId, section, complete);

    scheduleSection = (observationId: string, section: number, date: DateTimeDTO) =>
        this.formalApi.scheduleSection(observationId, section, date);

    submitSection = (observationId: string, section: number) =>
        this.formalApi.submitSection(observationId, section);

    skipSection = (observationId: string, section: number) =>
        this.formalApi.skipSection(observationId, section);

    restoreSection = (observationId: string, section: number) =>
        this.formalApi.restoreSection(observationId, section);

    getNotes = (observationId: string) =>
        this.formalApi.getNotes(observationId);

    addUnassignedNote = (note: FormalCreateNoteRequestDTO) =>
        this.formalApi.addUnassignedNote(note);

    getRubricForFormal = (observationId: string) =>
        this.formalApi.getRubricForFormal(observationId);

    getSummary = (observationId: string) =>
        this.formalApi.getSummary(observationId);

    createSummary = (observationId: string) =>
        this.formalApi.createSummary(observationId);

    saveSummary = (summary: FormalSummaryUpdateDto) =>
        this.formalApi.saveSummary(summary);

    submitSummary = (summary: FormalSummaryUpdateDto) =>
        this.formalApi.submitSummary(summary);

    updateUnassignedNote = (note: FormalUpdateNoteRequestDTO) =>
        this.formalApi.updateUnassignedNote(note);

    deleteUnassignedNote = (noteId: string) =>
        this.formalApi.deleteUnassignedNote(noteId);

    updateDistributeEvidenceDraft = (formalId: string, notes: FormalDistributeNotesDTO[]) =>
        this.formalApi.updateDistributeEvidenceDraft(formalId, notes);

    distributeUnassignedNote = (formalId: string, notes: FormalDistributeNotesDTO[]) =>
        this.formalApi.distributeUnassignedNote(formalId, notes);

    authorizeFormal = (formalId: string, signature: SignatureDTO) =>
        this.formalApi.authorizeFormal(formalId, signature);

    unauthorizeFormal = (formalId: string) =>
        this.formalApi.unauthorizeFormal(formalId);
}